import "@hotwired/turbo-rails"
import "@rails/actiontext"
import "chartkick/chart.js"

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Setup Stimulus
import "./controllers"

import "./toast"
import "./stripe"
import "./activestorage/direct_upload"

import LocalTime from "local-time"
LocalTime.start()
window.LocalTime = LocalTime

import "bootstrap/js/dist/alert"
import "bootstrap/js/dist/button"
import "bootstrap/js/dist/carousel"
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/offcanvas"
import "bootstrap/js/dist/dropdown"
import "bootstrap/js/dist/modal"
import "bootstrap/js/dist/tab"
// import "bootstrap/js/dist/popover"
// import "bootstrap/js/dist/scrollspy"
// import "bootstrap/js/dist/toast"
// import "bootstrap/js/dist/tooltip"

import "@37signals/lexxy"

